const Dataset = () => import('@/views/pages/metadata/dataset/index.vue');
const DatasetAnalysis = () => import('@/views/pages/metadata/datasetAnalysis/index.vue');
const DataWheel = () => import('@/views/pages/metadata/datawheel/index.vue');
const MetaModel = () => import('@/views/pages/metadata/metaModel/index.vue');
const MetaModelDetail = () => import('@/views/pages/myworkspace/metaModelDetail/index.vue');
const dataStandards = () => import('@/views/pages/metadata/dataStandards/index.vue');
const FutureDataSet = () => import('@/views/pages/metadata/futureDataSet/index.vue');
const MyDataStandards = () => import('@/views/pages/myworkspace/myDataStandards/index.vue');
const MyStandRequest = () => import('@/views/pages/myworkspace/myStandRequest/index.vue');
const RuleOverview = () => import('@/views/pages/dataQuality/ruleOverview/index.vue');
const RuleTemplate = () => import('@/views/pages/dataQuality/ruleTemplate/index.vue');
const JobOverview = () => import('@/views/pages/dataQuality/jobOverview/index.vue');
// const JobDetail2 = () => import('@/views/pages/dataQuality/jobDetail/index.vue');
const JobDetail = () => import('@/views/pages/dataQuality/jobDetail/index.vue');
const basicKPIManagement = () => import('@/views/pages/myworkspace/basicKPIManagement/index.vue');
const basicKPIOne = () => import('@/views/pages/myworkspace/basicKPIOne/index.vue');
const basicKPITwo = () => import('@/views/pages/myworkspace/basicKPITwo/index.vue');
const KpiDetail = () => import('@/views/pages/myworkspace/kpiDetail/index.vue');
const basicDimension = () => import('@/views/pages/kpiCatalog/basicDimension/index.vue');
const BusinessTermin = () => import('@/views/pages/dataStandard/standards/index.vue');
const FoundationalModal = () => import('@/views/pages/dataStandard/standards/components/foundationalModal/index.vue');
const masterDataCatalog = () => import('@/views/pages/masterData/masterDataCatalog/index.vue');
const MetaOverview = () => import('@/views/pages/metadata/metaOverview/index.vue');

const MasterDataDetail = () => import('@/views/pages/masterData/masterDataCatalog/masterDataManagement/index.vue');

const EntityDetail = () => import('@/views/pages/masterData/masterDataCatalog/entityDetail/index.vue');

const Attribute = () => import('@/views/pages/masterData/masterDataCatalog/attribute/index.vue');

const AttributeTable = () => import('@/views/pages/masterData/masterDataCatalog/attributeTable/index.vue');
const ServiceManagement = () => import('@/views/pages/masterData/serviceManage/index.vue');
const dataSourceManagement = () =>
  import('@/views/pages/myworkspace/metadataManagement/dataSourceManagement/index.vue');
const collectionRecords = () => import('@/views/pages/myworkspace/metadataManagement/collectionRecords/index.vue');
const dataSourceDetail = () => import('@/views/pages/myworkspace/metadataManagement/dataSourceDetail/index.vue');
const requestDetail = () => import('@/views/pages/myworkspace/requestDetail/index.vue');
const businessGlossaryManagementDetail = () =>
  import('@/views/pages/dataStandard/standards/components/businessGlossary/detail.vue');
const RuleTemplateDetailManage = () => import('@/views/pages/dataQuality/ruleTemplate/ruleTemplateDetail.vue');
const FutureDataSetDetailManage = () => import('@/views/pages/metadata/futureDataSet/Detail.vue');
const dataQualityPermission = () => import('@/views/pages/dataQuality/dataQualityPermission/index.vue');
const basicDimensionDetail = () => import('@/views/pages/kpiCatalog/basicDimension/detail.vue');
const RuleDetail = () => import('@/views/pages/dataQuality/ruleDetail/index.vue');
const DqIssues = () => import('@/views/pages/dataQuality/dataQualityIssue/index.vue');
const DqIssuesDetail = () => import('@/views/pages/dataQuality/dataQualityIssueDetail/index.vue');
const DqIssueDetail = () => import('@/views/pages/myworkspace/dqIssueDetail/index.vue');

const DataQualityPermissionRequestDetail = () =>
  import('@/views/pages/dataQuality/dataQualityPermissionRequestDetail/index.vue');

const TPDataModelManage = () => import('@/views/pages/dataResource/dataModel/TPModel/index.vue');
const APDataModelManage = () => import('@/views/pages/dataResource/dataModel/APModel/index.vue');
const ModelEntityManage = () => import('@/views/pages/dataResource/dataModel/EntityManage/index.vue');

const LogicalEntityManage = () => import('@/views/pages/dataResource/dataModel/LogicalEntityManagement/index.vue');
const DataModelView = () => import('@/views/pages/dataResource/dataModel/dataModelView/index.vue');
const DataStandardsAssociation = () => import('@/views/pages/myworkspace/dataStandardsAssociation/index.vue');
const DataFlowManagement = () => import('@/views/pages/masterData/dataFlow/index.vue');
const MasterDataApiRegistration = () => import('@/views/pages/masterData/masterDataApi/registration.vue');
const MasterDataApiConsumption = () => import('@/views/pages/masterData/masterDataApi/consumption.vue');
const DataModelVersion = () => import('@/views/pages/dataResource/dataModel/version/index.vue');
const DataModelUpdatedSummary = () => import('@/views/pages/dataResource/dataModel/UpdatedSummary/index.vue');

// data resource catalog
const DataResourceCatalogManagement = () =>
  import('@/views/pages/myworkspace/dataResourceCatalog/typeManagement/index.vue');
const DataResourceCatalogDetailManagement = () =>
  import('@/views/pages/myworkspace/dataResourceCatalog/typeDetailManagement/index.vue');
const DataResourceCatalogEntityManagement = () =>
  import('@/views/pages/myworkspace/dataResourceCatalog/entityManagement/index.vue');
const DataResourceCatalogEntityDetailManagement = () =>
  import('@/views/pages/myworkspace/dataResourceCatalog/entityDetailManagement/index.vue');

//Use Case

const useCaseList = () => import('@/views/pages/useCase/useCaseList/index.vue');
const useCaseForm = () => import('@/views/pages/useCase/useCaseForm/index.vue');
const dataUseCase = () => import('@/views/pages/useCase/dataUseCase/index.vue');
const sfUseCase = () => import('@/views/pages/useCase/sfUseCase/index.vue');

const useCaseAdminPanel = () => import('@/views/pages/useCase/useCaseSquare/index.vue');

const aiGovernanceList = () => import('@/views/pages/myworkspace/aiGovernance/aiGovernanceList/index.vue');
const preCheckList = () => import('@/views/pages/myworkspace/aiGovernance/preCheckList/index.vue');
const aiGovernanceUcRiskResult = () => import('@/views/pages/myworkspace/aiGovernance/ucRiskResult/index.vue');

const conformityCheckConfig = () => import('@/views/pages/myworkspace/aiGovernance/conformityCheckConfig/index.vue');
const conformityCheckInput = () => import('@/views/pages/myworkspace/aiGovernance/conformityCheckInput/index.vue');
const aiGovernanceDetail = () => import('@/views/pages/myworkspace/aiGovernance/detail/index.vue');

const AiUseCaseAssistant = () => import('@/views/pages/useCase/aiUseCaseAssistant/index.vue');
const GaiaUseCase = () => import('@/views/pages/useCase/gaiaUseCase/index.vue');

const dataResourceList = () => import('@/views/pages/myworkspace/dataResourceManage/list/index.vue');
const dataResourceDetail = () => import('@/views/pages/myworkspace/dataResourceManage/detail/index.vue');

const AuthorizationManagement = () =>
  import('@/views/pages/myworkspace/dataResourceManage/authorizationManagement/index.vue');

const BusinessObjectManagementUserGuidance = () =>
  import('@/views/pages/myworkspace/businessObjectManagement/detail/index.vue');
const BusinessObjectManageList = () => import('@/views/pages/myworkspace/businessObjectManagement/list/index.vue');
const DataEngineerTeamManagement = () => import('@/views/pages/dataQuality/DataEngineerTeamManagement/index.vue');

const workSpaceRouteList = [
  {
    path: 'metaModeldetail',
    component: MetaModelDetail,
    name: '/metaModeldetail',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Meta Model Detail',
      mid: '9b1e-5f28',
    },
  },
  {
    path: 'datasetAnalysisWork',
    component: DatasetAnalysis,
    name: '/datasetAnalysisWork',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'datasetAnalysis',
      mid: '5d3a-8c91',
    },
  },
  {
    path: 'dataStandards',
    component: dataStandards,
    name: '/dataStandards',
    key: '/dataStandards',
    meta: {
      ownType: 'MyWorkspace',
      mid: 'e0b7-4d2f',
    },
  },
  {
    path: 'myDataStandards',
    component: MyDataStandards,
    name: '/myDataStandards',
    key: '/myDataStandards',
    meta: {
      ownType: 'MyWorkspace',
      mid: '8a6d-1f3c',
    },
  },
  {
    path: 'myRequest',
    component: MyStandRequest,
    name: '/myStandRequest',
    key: '/myStandRequest',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Request',
      mid: '1c9f-5b84',
    },
  },
  {
    path: 'datawheelManage',
    component: DataWheel,
    name: '/datawheelManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Category(Data Wheel)',
      mid: 'f3a7-8d02',
    },
  },
  {
    path: 'dataassetManage',
    component: Dataset,
    name: '/dataassetManage',
    meta: {
      ownType: 'MyWorkspace',
      mid: '6b0e-9c45',
      lableTitle: 'Data Asset & Dataset',
    },
  },
  {
    path: 'futuredatasetManage',
    component: FutureDataSet,
    name: '/futuredatasetManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Asset Requirement',
      mid: 'd4a1-7f28',
    },
  },
  {
    path: 'metaModelManage',
    component: MetaModel,
    name: '/metaModelManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Meta Model',
      mid: '2f9b-6c05',
    },
  },
  {
    path: 'dataStandardsManage',
    component: MetaModel,
    name: '/dataStandardsManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Standards',
      mid: 'a8d0-4e71',
    },
  },
  {
    path: 'myrequestManage',
    component: MetaModel,
    name: '/myrequestManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'My Request',
      mid: '7e5b-9c12',
    },
  },

  {
    path: 'dqrule',
    component: RuleOverview,
    name: '/dqrule',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Rule',
      mid: '0d4a-8f63',
    },
  },
  {
    path: 'dqruleTemplate',
    component: RuleTemplate,
    name: '/dqruleTemplate',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Rule Template',
      mid: 'c9b1-5e26',
    },
  },
  {
    path: 'dqjob',
    component: JobOverview,
    name: '/dqjob',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Jobs',
      mid: '4f2a-8d19',
    },
  },

  {
    path: 'myWorkjobDetail',
    component: JobDetail,
    name: '/myWorkjobDetail',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Quality JobDetail',
    },
  },
  // {
  //   path: 'myWorkjobDetail2',
  //   component: JobDetail2,
  //   name: '/myWorkjobDetail2',
  //   meta: {
  //     ownType: 'MyWorkspace',
  //     lableTitle: 'Data Quality JobDetail',
  //   },
  // },
  {
    path: 'basicKPIManagement',
    component: basicKPIManagement,
    name: '/basicKPIManagement',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'KPI Standard Definition',
      mid: '1a6f-9c48',
    },
  },

  {
    path: 'basicKPIOne',
    component: basicKPIOne,
    name: '/basicKPIOne',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Basic KPI Management',
      mid: 'e3d7-0a5b',
    },
  },

  {
    path: 'kpiDetail',
    component: KpiDetail,
    name: '/kpiDetail',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Basic KPI Management',
      mid: '8c9a-1f64',
    },
  },

  {
    path: 'myDataStandardsManage',
    component: MetaModel,
    name: '/myDataStandardsManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'My Data Standards',
      mid: '5b2e-8d07',
    },
  },
  {
    path: 'referenceDataManagement',
    component: basicDimension,
    name: '/referenceDataManagement',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Reference Data ',
      mid: 'f0a9-4c31',
    },
  },
  {
    path: 'basicKPITwo',
    component: basicKPITwo,
    name: '/basicKPITwo',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'KPI Standard Definition',
      mid: '3d7b-9e02',
    },
  },
  {
    path: 'businessGlossaryManagement',
    component: BusinessTermin,
    name: '/businessGlossaryManagement',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Business Glossary ',
      mid: 'a6c1-8f54',
    },
  },
  {
    path: 'businessGlossaryManagementDetail',
    component: businessGlossaryManagementDetail,
    name: '/businessGlossaryManagementDetail',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Business Glossary',
      mid: '9d2e-7b01',
    },
  },
  {
    path: 'foundationalManage',
    component: BusinessTermin,
    name: '/foundationalManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Foundational Data Standards ',
      mid: '4e0a-9d53',
    },
  },
  {
    path: 'foundationalManageDetail',
    component: FoundationalModal,
    name: '/foundationalManageDetail',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Foundational Data Standards',
      mid: '2b7c-8f16',
    },
  },
  {
    path: 'dataStandardsAssociation',
    component: DataStandardsAssociation,
    name: '/dataStandardsAssociation',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Standards Association',
      mid: 'c1a9-6d03',
    },
  },
  {
    path: 'masterDataCatalogManage',
    component: masterDataCatalog,
    name: '/masterDataCatalogManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Mater Data Catalog',
      mid: '7f8b-4e12',
    },
  },
  {
    path: 'masterDataDetailManage',
    component: MasterDataDetail,
    name: '/masterDataDetailManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Mater Data Detail',
      mid: '0e5d-9a24',
    },
  },
  {
    path: 'entityDetailManage',
    component: EntityDetail,
    name: '/entityDetailManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Entity Detail',
      mid: 'd9a2-7f41',
    },
  },
  {
    path: 'Attribute',
    component: Attribute,
    name: '/Attribute',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Attribute Management',
      mid: '6b3c-8e05',
    },
  },
  {
    path: 'AttributeTable',
    component: AttributeTable,
    name: '/AttributeTable',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Associate Data Service',
      mid: 'a4d9-1f72',
    },
  },
  {
    path: 'serviceManagement',
    component: ServiceManagement,
    name: '/serviceManagement',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Service',
      mid: '1e8b-5d03',
    },
  },
  {
    path: 'dataSourceManagement',
    component: dataSourceManagement,
    name: '/dataSourceManagement',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Source',
      mid: 'f2a7-9c14',
    },
  },
  {
    path: 'collectionRecords',
    component: collectionRecords,
    name: '/collectionRecords',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Collection Records',
      mid: '5d0b-8e69',
    },
  },
  {
    path: 'dataQualityPermission',
    component: dataQualityPermission,
    name: '/dataQualityPermission',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Asset Permission',
      mid: 'c3a9-7d12',
    },
  },
  {
    path: 'requestDetail',
    component: requestDetail,
    name: '/requestDetail',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Request Detail',
      mid: '8e1b-4f05',
    },
  },
  {
    path: 'dataSourceDetail',
    component: dataSourceDetail,
    name: '/dataSourceDetail',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Source Detail',
      mid: '9a7d-2e14',
    },
  },
  {
    path: 'ruleTemplateDetailManage',
    component: RuleTemplateDetailManage,
    name: '/ruleTemplateDetailManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Rule Detail',
      mid: '2f6b-8c91',
    },
  },
  {
    path: 'futureDataSetDetailManage',
    name: '/futureDataSetDetailManage',
    component: FutureDataSetDetailManage,
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Future Data Asset Detail ',
      mid: 'b4d0-7a2e',
    },
  },
  {
    path: 'referenceDataDetailManage',
    component: basicDimensionDetail,
    name: '/referenceDataDetailManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Reference Data Detail ',
      mid: '0a9e-5f13',
    },
  },
  {
    path: 'ruleDetailManage',
    component: RuleDetail,
    name: '/ruleDetailManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Rule Detail',
      mid: 'e1b7-8d42',
    },
  },
  {
    path: 'dqIssues',
    component: DqIssues,
    name: '/dqIssues',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Issues',
      mid: '7c2a-9f15',
    },
  },
  {
    path: 'dqIssuesDetail',
    component: DqIssuesDetail,
    name: '/dqIssuesDetail',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Issues',
      mid: '3d8b-6e01',
    },
  },
  {
    path: 'dqIssueDetail',
    component: DqIssueDetail,
    name: '/dqIssueDetail',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Issue Detail',
      mid: 'a5f0-9c27',
    },
  },
  {
    path: 'dataQualityPermissionRequestDetail',
    component: DataQualityPermissionRequestDetail,
    name: '/dataQualityPermissionRequestDetail',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Request Detail',
      mid: '4b1e-8d53',
    },
  },
  {
    path: 'tPDataModelManage',
    component: TPDataModelManage,
    name: '/tPDataModelManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Transactional Data Model Management',
      mid: '1c9a-7f28',
    },
  },
  {
    path: 'aPDataModelManage',
    component: APDataModelManage,
    name: '/aPDataModelManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Analytical Data Model Management',
      mid: 'f6b2-8d05',
    },
  },

  {
    path: 'entityManage',
    component: ModelEntityManage,
    name: '/entityManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Logical Entity Management',
      mid: '5a0e-9c37',
    },
  },
  {
    path: 'logicalEntityManage',
    component: LogicalEntityManage,
    name: '/logicalEntityManage',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Logical Entity Management',
      mid: 'd3b8-7a14',
    },
  },
  {
    path: 'dataModelViewManagement',
    component: DataModelView,
    name: '/dataModelViewManagement',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Model View',
      mid: '8e2a-9f05',
    },
  },
  {
    path: 'dataFlow',
    component: DataFlowManagement,
    name: '/dataFlow',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Flow',
      mid: '2b7d-8c41',
    },
  },
  {
    path: 'masterDataApiRegistration',
    component: MasterDataApiRegistration,
    name: '/masterDataApiRegistration',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Master Data API Management',
      mid: 'c6a9-1f53',
    },
  },
  {
    path: 'masterDataApiConsumption',
    component: MasterDataApiConsumption,
    name: '/masterDataApiConsumption',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Master Data API Consumption',
      mid: '9d0b-7e24',
    },
  },
  {
    path: 'dataModelVersion',
    component: DataModelVersion,
    name: '/dataModelVersion',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Model Branch Management',
      mid: '4e1a-9d85',
    },
  },
  {
    path: 'dataModelUpdatedSummary',
    component: DataModelUpdatedSummary,
    name: '/dataModelUpdatedSummary',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Version Update Summary',
      mid: 'a3b7-8c02',
    },
  },
  {
    path: 'metadataoverview',
    component: MetaOverview,
    name: '/metadataoverview',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Metadata Score Report',
      mid: '1f5d-9a24',
    },
  },
  {
    path: 'myUseCase',
    component: useCaseList,
    name: '/myUseCase',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Use Case Square',
      mid: 'e0b8-7d43',
    },
  },

  {
    path: 'useCaseForm',
    component: useCaseForm,
    name: '/useCaseForm',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Use Case Form',
      mid: '7a2d-9f16',
    },
  },
  {
    path: 'dataUseCase',
    component: dataUseCase,
    name: '/dataUseCase',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Use Case Form',
      mid: '3c8b-6e05',
    },
  },
  // {
  //   path: 'dataResourceCatalogManagement',
  //   component: DataResourceCatalogManagement,
  //   name: 'dataResourceCatalogManagement',
  //   meta: {
  //     ownType: 'MyWorkspace',
  //     lableTitle: 'Data Resource Type',
  //   },
  // },
  {
    path: 'dataResourceCatalogDetailManagement',
    component: DataResourceCatalogDetailManagement,
    name: 'dataResourceCatalogDetailManagement',
    meta: {
      ownType: 'MyWorkspace',
      /* lableTitle: 'Data Resource Type Detail', */
      mid: '8d1e-4f53',
    },
  },
  {
    path: 'dataResourceCatalogEntityManagement',
    component: DataResourceCatalogEntityManagement,
    name: 'dataResourceCatalogEntityManagement',
    meta: {
      ownType: 'MyWorkspace',
      /* lableTitle: 'Data Resource Entity', */
      mid: '2a9b-7c16',
    },
  },
  {
    path: 'dataResourceCatalogEntityDetailManagement',
    component: DataResourceCatalogEntityDetailManagement,
    name: 'dataResourceCatalogEntityDetailManagement',
    meta: {
      ownType: 'MyWorkspace',
      /* lableTitle: 'Data Resource Entity Detail', */
      mid: 'f1d8-5a24',
    },
  },
  {
    path: 'useCaseAdminPanel',
    component: useCaseAdminPanel,
    name: '/useCaseAdminPanel',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Admin Panel',
      mid: 'b5a0-9d27',
    },
  },
  {
    path: 'useCaseAdminPanel',
    component: useCaseAdminPanel,
    name: '/useCaseAdminPanel',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Admin Panel',
    },
  },
  {
    path: 'aiGovernanceList',
    component: aiGovernanceList,
    name: 'aiGovernanceList',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'AI Governance',
      mid: '6e0b-9c37',
    },
  },
  {
    path: 'preCheckList',
    component: preCheckList,
    name: 'preCheckList',
    meta: {
      ownType: 'MyWorkspace',
      mid: 'c4a2-8d15',
    },
  },
  {
    path: 'aiGovernanceUcRiskResult',
    component: aiGovernanceUcRiskResult,
    name: 'aiGovernanceUcRiskResult',
    meta: {
      ownType: 'MyWorkspace',
      mid: '9b7d-2e04',
    },
  },
  {
    path: 'conformityCheckConfig',
    component: conformityCheckConfig,
    name: 'conformityCheckConfig',
    meta: {
      ownType: 'MyWorkspace',
      mide: '5d1a-8f63',
    },
  },
  {
    path: 'conformityCheckInput',
    component: conformityCheckInput,
    name: 'conformityCheckInput',
    meta: {
      ownType: 'MyWorkspace',
      mide: 'a0e9-7d42',
    },
  },
  {
    path: 'conformityCheck',
    component: conformityCheckInput,
    name: 'conformityCheck',
    meta: {
      ownType: 'MyWorkspace',
      mid: '1b6f-9c58',
    },
  },
  {
    path: 'aiUseCaseAssistant',
    component: AiUseCaseAssistant,
    name: '/aiUseCaseAssistant',
    meta: {
      ownType: 'MyWorkspace',
      // aigovernance合并路由
      mid: 'e2d7-0a4b',
    },
  },
  {
    path: 'gaiaUseCase',
    component: GaiaUseCase,
    name: '/gaiaUseCase',
    meta: {
      ownType: 'MyWorkspace',
      // aigovernance合并路由
      mid: '7c9a-1f64',
    },
  },
  {
    path: 'aiGovernanceDetail',
    component: aiGovernanceDetail,
    name: 'aiGovernanceDetail',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'AI Governance',
      mid: '3b2e-8d07',
    },
  },
  {
    path: 'dataResourceCatalogManagement',
    component: dataResourceList,
    name: 'dataResourceCatalogManagement',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Resource',
      mid: 'f4a9-5c31',
    },
  },
  {
    path: 'dataResourceDetail',
    component: dataResourceDetail,
    name: 'dataResourceDetail',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Resource',
      mid: '8d7b-9e02',
    },
  },
  {
    path: 'delegationSetup',
    component: AuthorizationManagement,
    name: 'delegationSetup',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Resource',
      mid: '6a1c-8f54',
    },
  },
  {
    path: 'businessObjectManagementUserGuidance',
    component: BusinessObjectManagementUserGuidance,
    name: 'businessObjectManagementUserGuidance',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Resource',
      mid: 'b9d2-7e01',
    },
  },
  {
    path: 'businessObjectManagementList',
    component: BusinessObjectManageList,
    name: 'businessObjectManagementList',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Resource',
      mid: '0e4a-9d53',
    },
  },
  {
    path: '/dataEngineerTeam',
    component: DataEngineerTeamManagement,
    name: '/dataEngineerTeam',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: 'Data Engineer Team Management',
      mid: 'c2b7-8f16',
    },
  },
  {
    path: 'sfUseCase',
    component: sfUseCase,
    name: '/sfUseCase',
    meta: {
      ownType: 'MyWorkspace',
      lableTitle: '',
      mid: '5a1d-6e03',
    },
  },
];

export default workSpaceRouteList;
